module.exports = __webpack_public_path__ + "static/media/logo-싸이멕스@3x.3e0fc646.png";